import * as React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Container, Typography } from '@mui/material';

const PlnarHelp = (props) => {
  return (
    <Container maxWidth="xl">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>What is Personal Architect?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>Personal Architect is a cloud-based home design tool that takes advantage of artificial intelligence to guide homeowners and designers in a collaborative experience.</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>What is Plnar?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>Plnar is the fastest, easiest, most accurate way to create 3D models of any interior space with a smartphone or tablet. You simply take photos of the room you want to design, upload them in Plnar and you can start designing.</Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>How can this help me?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>If you need to design a room, Personal Architect and Plnar allows you to create a 3D model of a room that meets your exact specifications using only photos of the original space.</Typography>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}

export default PlnarHelp